const typography: any = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  h1: {
    fontWeight: 700,
    fontSize: '3rem',
    lineHeight: '3.5rem',
    letterSpacing: '-0.02em',
  },
  h2: {
    fontWeight: 600,
    fontSize: '2rem',
    lineHeight: '2.5rem',
    letterSpacing: '-0.01em',
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    letterSpacing: '-0.01em',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
  },
  h5: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  h6: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    letterSpacing: '0.01em',
  },
  body1: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.25rem',
  },
  body2: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1rem',
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
  },
  caption: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: '0.875rem',
    letterSpacing: '0.05em',
  },
  overline: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: '0.875rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
};

export default typography;
